export interface Companion {
  id: string
  name: string
  age: number
  nationality: string
  height: string
  measurements: string
  tags: string[]
  imageUrl: string
  price: string
  verified: boolean
  rating: number
}

export const companions: Companion[] = [
  {
    id: '1',
    name: 'Sophia 索菲亚',
    age: 23,
    nationality: 'Russia 🇷🇺',
    height: '172cm',
    measurements: '34C-24-35',
    tags: ['Model', 'English', 'Party'],
    imageUrl:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 800+',
    verified: true,
    rating: 5.0,
  },
  {
    id: '2',
    name: 'Yuki 雪',
    age: 21,
    nationality: 'Japan 🇯🇵',
    height: '162cm',
    measurements: '32C-23-33',
    tags: ['Sweet', 'Japanese', 'Dinner'],
    imageUrl:
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 1000+',
    verified: true,
    rating: 4.9,
  },
  {
    id: '3',
    name: 'Isabella 伊莎贝拉',
    age: 25,
    nationality: 'Brazil 🇧🇷',
    height: '175cm',
    measurements: '36D-25-38',
    tags: ['Passionate', 'English', 'Travel'],
    imageUrl:
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 900+',
    verified: true,
    rating: 5.0,
  },
  {
    id: '4',
    name: 'Ji-min 智敏',
    age: 22,
    nationality: 'Korea 🇰🇷',
    height: '168cm',
    measurements: '34B-24-34',
    tags: ['K-Pop Style', 'Korean', 'Shopping'],
    imageUrl:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 1200+',
    verified: true,
    rating: 4.8,
  },
  {
    id: '5',
    name: 'Linh 琳',
    age: 20,
    nationality: 'Vietnam 🇻🇳',
    height: '165cm',
    measurements: '32B-22-33',
    tags: ['Gentle', 'Chinese', 'Massage'],
    imageUrl:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 600+',
    verified: true,
    rating: 4.7,
  },
  {
    id: '6',
    name: 'Emma 艾玛',
    age: 24,
    nationality: 'UK 🇬🇧',
    height: '170cm',
    measurements: '34C-24-36',
    tags: ['Elegant', 'English', 'Business'],
    imageUrl:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 1500+',
    verified: true,
    rating: 5.0,
  },
  {
    id: '7',
    name: 'Si Qi 思琪',
    age: 22,
    nationality: 'China 🇨🇳',
    height: '166cm',
    measurements: '33C-23-34',
    tags: ['Student', 'Chinese', 'Movie'],
    imageUrl:
      'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 700+',
    verified: true,
    rating: 4.8,
  },
  {
    id: '8',
    name: 'Sakura 樱',
    age: 26,
    nationality: 'Japan 🇯🇵',
    height: '160cm',
    measurements: '34D-24-35',
    tags: ['Mature', 'Japanese', 'Golf'],
    imageUrl:
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?q=80&w=1000&auto=format&fit=crop',
    price: 'SGD 1100+',
    verified: true,
    rating: 4.9,
  },
]
